export const renameKeys = (keysMap, obj) => Object
.keys(obj)
.reduce((acc, key) => ({
    ...acc,
    ...{ [keysMap[key] || key]: obj[key] }
}), {});

export const countDecimals = (value) => {
    if ((value % 1) != 0) 
        return value.toString().split(".")[1].length;  
    return 0;
}

export const getUrlParameter = (name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const findAncestor = (el, sel) => {
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,sel)));
    return el;
}

export const addClass = (target,className) => {
    let el = typeof target === 'object' ? target : document.querySelector(target);
    el.classList.add(className);
}

export const removeClass = (target,className) => {
    let el = typeof target === 'object' ? target : document.querySelector(target);
    el.classList.remove(className);
}

export const toggleClass = (target,className) => {
    let el = typeof target === 'object' ? target : document.querySelector(target);
    if(!hasClass(el,className)) {
        el.classList.add(className);
    } else {
        el.classList.remove(className);
    }
}

export const hasClass = (target,className) => {
    let el = typeof target === 'object' ? target : document.querySelector(target);
    return el.classList.contains(className);
}

export const lockScroll = () => {
    addClass('html','noscroll');
    addClass('body','noscroll');
};
export const unlockScroll = () => {
    removeClass('html','noscroll');
    removeClass('body','noscroll');
};
export const toggleScroll = () => {
    if(!hasClass('html','noscroll')) {
        addClass('html','noscroll');
    } else {
        removeClass('html','noscroll');
    }
    if(!hasClass('body','noscroll')) {
        addClass('body','noscroll');
    } else {
        removeClass('body','noscroll');
    }
};

export const isElementInViewport = (el) => {

    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && 
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}